<template>
  <div class="right-header">
    <div class="header-left">
      <i class="el-icon-user"></i>
      <span>name</span>
    </div>
    <i class="el-icon-switch-button"></i>
  </div>
</template>

<script>
export default {
  name: "NavHeader"
}
</script>

<style lang="less" scoped>
.right-header{
  height: 5vh;
  background-color:whitesmoke;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  line-height: 5vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .header-left{
    i{
      padding-right: 10px;
    }
  }
}
</style>